import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import CustomerAccountInput from 'components/Common/Inputs/CustomerAccountInput';
import ModalWrapper from 'components/Modals/ModalWrapper';

class EditFormAssociationsModalForm extends Component {
  static propTypes = {
    onConfirmFormAssociations: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    isShown: PropTypes.bool.isRequired,
    currentForm: PropTypes.shape(),
    selectedClient: PropTypes.shape()
  };

  static defaultProps = {
    currentForm: null,
    selectedClient: null
  };

  constructor(props) {
    super(props);
    this.state = {
      isRequestingEditFormAssociations: false,
      customerAccountSelection: (props.currentForm && props.currentForm.accountId === 0) ? { customerId: props.currentForm.customerDbId } : null
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    const { customerAccountSelection } = this.state;
    const { onConfirmFormAssociations } = this.props;

    if (!customerAccountSelection) {
      toastr.error('', 'Please select a shareholder and account(s)');
      return;
    }

    if (!customerAccountSelection.selectionValid) {
      toastr.error('', 'Please correct the selections you have made');
      return;
    }

    onConfirmFormAssociations(customerAccountSelection);
  }

  setCustomerAccountCallback(value) {
    this.setState({ customerAccountSelection: value });
  }

  render() {
    const { onCancel, isShown, currentForm, selectedClient } = this.props;
    const { isRequestingEditFormAssociations } = this.state;

    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title="Edit Shareholder &amp; Account(s) Linked to Form"
        btnConfirmTitle="Confirm Change"
        btnConfirmClass={ `btn-danger ${ isRequestingEditFormAssociations ? 'loading' : '' }` }
        btnCancelTitle="Cancel"
        onConfirm={ this.handleSubmit }
        onCancel={ onCancel }
        modalSize="edit-form-associations-modal"
      >

        <form id="editFormAssociationsForm" name="editFormAssociationsForm" className="form-horizontal edit-form-associations-modal" onSubmit={ this.handleSubmit }>
          <div className="form-group">
            <div className="col-3">
              Form Type
            </div>
            <div className="col-9 bold">
              { currentForm && <React.Fragment>{ currentForm.formType } { currentForm.entityName && <React.Fragment> - { currentForm.entityName }</React.Fragment> }</React.Fragment> }
            </div>
          </div>
          <div className="form-group">
            <div className="col-3">
              Assigned Shareholder
            </div>
            <div className="col-9 bold">
              { currentForm && currentForm.customerId }{ currentForm.customerName && <React.Fragment> / { currentForm.customerName }</React.Fragment> }
              { currentForm && !currentForm.customerId && <React.Fragment>None</React.Fragment> }
            </div>
          </div>
          <div className="form-group">
            <div className="col-3">
              Assigned Account(s)
            </div>
            <div className="col-9 bold">
              { currentForm && currentForm.accountId > 0 && currentForm.accountNumber }{ currentForm.accountName && <React.Fragment> / { currentForm.accountName }</React.Fragment> }
              { currentForm && currentForm.accountId === 0 && <React.Fragment>None</React.Fragment> }
            </div>
          </div>
          <div className="separator">
            <hr size="1" />
            <p>To change the shareholder / account(s) linked to the form, please choose from the options below</p>
          </div>
          <CustomerAccountInput
            clientId={ (selectedClient && selectedClient.key) || 0 }
            initialSelections={ {
              customer: currentForm && currentForm.accountId === 0 && currentForm.customerDbId && currentForm.customerIsActive ? { id: currentForm.customerDbId, customerId: currentForm.customerId, name: currentForm.customerName } : null,
              newAccount: currentForm && currentForm.accountId === 0 && currentForm.customerDbId && currentForm.customerIsActive
            } }
            accountExclusions={ currentForm && currentForm.accountId > 0 ? [currentForm.accountId] : [] }
            onSelectionChange={ data => this.setCustomerAccountCallback(data) }
          />
        </form>
      </ModalWrapper>
    );
  }
}

const EditFormAssociationsModalReduxForm = reduxForm({
  form: 'editFormAssociationsForm'
})(EditFormAssociationsModalForm);

const mapDispatchToProps = dispatch => ({ dispatch });

function mapStateToProps(state) {
  const {
    auth: {
      settings: {
        selectedClient
      }
    },
    forms: {
      isRequestingEditFormAssociations,
      currentForm
    }
  } = state;

  return {
    isRequestingEditFormAssociations,
    currentForm,
    selectedClient
  };
}

export const EditFormAssociationsModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditFormAssociationsModalReduxForm);

export default EditFormAssociationsModal;
